module.exports = __webpack_public_path__ + "img/special.d23f38f3.png";